import { DropdownMenuItem } from '@nesso/ui/primitives/dropdown-menu';

interface UserDropdownInfoProps {
    name: string;
    email: string;
}

export function UserDropdownInfo({ name, email }: UserDropdownInfoProps) {
    return (
        <DropdownMenuItem className="cursor-default hover:bg-transparent focus-visible:bg-transparent p-2 pt-3 mx-1 ">
            <div className="flex items-center gap-2 min-w-0 flex-1">
                <span className="flex flex-col min-w-0">
                    <span className="flex items-start gap-0 p-0 m-0 h-5">
                        <p className="font-semibold text-popover-foreground truncate leading-4">
                            {name}
                        </p>
                    </span>
                    <p className="text-sm text-muted-foreground truncate">{email}</p>
                </span>
            </div>
        </DropdownMenuItem>
    );
}
